import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import TradingButton from '../components/Trader/TradingButton';

const items = [
  { label: 'Home', to: '/', icon: <HomeOutlinedIcon /> },
  { label: 'Link Wallet', to: '/connect-wallet', icon: <LinkOutlinedIcon /> },
  { label: 'History', to: '/account-wallet', icon: <ReceiptLongOutlinedIcon /> },
  { label: 'Assets', to: '/assets', icon: <AccountBalanceWalletOutlinedIcon /> },
];

export default function Footer() {
  const { pathname } = useLocation();
  const current = items.findIndex((item) =>
    item.to === '/' ? pathname === '/' : pathname.startsWith(item.to)
  );

  return (
    <Box sx={{ display: { md: 'none' }, pb: '52px' }}>
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          bgcolor: 'background.paper',
          color: 'text.primary',
          borderTop: 1,
          borderColor: 'divider',
        }}
        elevation={0}
      >
        {pathname === '/trade' ? (
          <TradingButton />
        ) : (
          <BottomNavigation
            showLabels
            value={current === -1 ? false : current}
            sx={{
              height: 52,
              bgcolor: 'transparent',
              '& .MuiBottomNavigationAction-root': {
                color: 'text.secondary',
                minWidth: 0,
                maxWidth: 'none',
                py: 0.5,
                fontFamily: '"Source Sans 3", "Segoe UI", sans-serif',
              },
              '& .MuiBottomNavigationAction-label': {
                fontFamily: '"Source Sans 3", "Segoe UI", sans-serif',
                fontSize: '10px',
                lineHeight: 1.1,
                fontWeight: 500,
                letterSpacing: '0.04em',
                whiteSpace: 'nowrap',
                '&.Mui-selected': { fontSize: '10px' },
              },
              '& .MuiSvgIcon-root': { fontSize: 20 },
              '& .Mui-selected': {
                color: 'primary.main',
              },
            }}
          >
            {items.map((item) => (
              <BottomNavigationAction
                key={item.to}
                component={RouterLink}
                to={item.to}
                label={item.label}
                icon={item.icon}
              />
            ))}
          </BottomNavigation>
        )}
      </Paper>
    </Box>
  );
}
